export default {
    header: "Você foi desconectado com sucesso",
    message: ""
}